import React from "react";

import { useDispatch, useSelector } from "react-redux";
import { changeConfirmingDisplayNameUpdate, changeFormDisplayName, displayNameUpdating, loadUserAfterDisplayNameUpdate, selectConfirmingDisplayNameUpdate, selectDisplayName } from "./displayNameSlice";
import { selectToken } from "../login/loginSlice";

import { Link, useNavigate } from "react-router-dom";

import './EditDisplayNameForm.css';

import Sidebar from "../../components/sidebar/Sidebar";
import ConfirmAction from "../../components/confirmAction/ConfirmAction";
import { selectUser } from "../home/userSlice";

export default function EditDisplayNameForm() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const token = useSelector(selectToken);

    const newDisplayName = useSelector(selectDisplayName);
    const updatingDisplayName = useSelector(displayNameUpdating);
    const confirmingDisplayNameUpdate = useSelector(selectConfirmingDisplayNameUpdate);

    const userInfo = useSelector(selectUser);
    const username = userInfo.username;

    const handleDisplayNameChange = (event) => {
        dispatch(changeFormDisplayName(event.target.value));
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        dispatch(changeConfirmingDisplayNameUpdate(true));
    }

    const handleConfirmCancelClick = () => {
        dispatch(changeConfirmingDisplayNameUpdate(false));
    }

    const handleConfirmUpdateClick = () => {
        dispatch(loadUserAfterDisplayNameUpdate({username: username, newDisplayName: newDisplayName, token}));
        dispatch(changeConfirmingDisplayNameUpdate(false));
        navigate("../settings");
    }

    return (
        <main>
            <Sidebar />
            <section className="edit-display-name-form">
                <h2>Edit Display Name</h2>
                <form onSubmit={handleSubmit}>
                    <label htmlFor="displayName">
                        Display Name: 
                        <input name="displayName" value={newDisplayName} onChange={handleDisplayNameChange}></input>
                    </label>
                    <div className="button-container">
                        <Link to={`../settings`}><button disabled={updatingDisplayName}>Cancel</button></Link>
                        <button type="submit" disabled={updatingDisplayName}>{updatingDisplayName ? "Updating..." : "Submit"}</button>
                    </div>
                </form>
                {confirmingDisplayNameUpdate ? <ConfirmAction handleConfirm={handleConfirmUpdateClick} handleCancel={handleConfirmCancelClick}/> : ""}
            </section>
        </main>
    )
}